import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agency-one-services',
  templateUrl: './agency-one-services.component.html',
  styleUrls: ['./agency-one-services.component.scss']
})
export class AgencyOneServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
